/* eslint-disable @angular-eslint/directive-selector */
import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { Subject, debounceTime, filter, take } from 'rxjs';
@Directive({
  selector: '[observeIntersection]',
})
export class ObserveIntersectionDirective implements AfterViewInit, OnDestroy {
  @Input() root: HTMLElement;
  @Input() rootMargin = '0px 0px 0px 0px';
  @Input() threshold = 1;
  @Input() observeAfterLoadedElement: string;

  @Output() startObservation: EventEmitter<void> = new EventEmitter();
  @Output() intersectionChange: EventEmitter<boolean> = new EventEmitter();
  @Output() impression: EventEmitter<ElementRef> = new EventEmitter();

  mutationObserver: MutationObserver;
  intersectionObserver: IntersectionObserver;
  intersectionSubject$: Subject<boolean>;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    this.intersectionObserver = new IntersectionObserver(
      entries => {
        for (const entry of entries) {
          this.intersectionSubject$?.next(entry?.isIntersecting);
        }
      },
      {
        root: this.root,
        rootMargin: this.rootMargin,
        threshold: this.threshold,
      },
    );

    this.intersectionSubject$ = new Subject<boolean>();
    this.intersectionSubject$
      .pipe(
        debounceTime(500),
        filter(isIntersecting => isIntersecting),
        take(1),
      )
      .subscribe(_ => {
        this.impression?.emit(this.el);
      });
    this.intersectionSubject$.subscribe(isIntersecting => {
      this.intersectionChange?.emit(isIntersecting);
    });

    this.observe();
  }

  ngOnDestroy() {
    this.mutationObserver?.disconnect();
    this.intersectionObserver?.disconnect();
    this.intersectionSubject$?.complete();
  }

  observe() {
    if (!!this.observeAfterLoadedElement) {
      this.mutationObserver = new MutationObserver((entries, observer) => {
        const element = document?.querySelector(this.observeAfterLoadedElement);

        if (element instanceof HTMLElement && element?.offsetHeight > 0) {
          this.intersectionObserver?.observe(this.el?.nativeElement);
          this.startObservation?.emit();
          observer?.disconnect();
        }
      });
      this.mutationObserver?.observe(document, {
        childList: true,
        subtree: true,
      });
    } else {
      this.intersectionObserver?.observe(this.el?.nativeElement);
      this.startObservation?.emit();
    }
  }
}
